module.exports = __webpack_public_path__ + "static/media/floor-plans-product.993e91ae.jpg";